<ion-content class="employee-cancel">
    <ng-container>
        <app-header  [title]="'Garment Return Review'"></app-header>
        <div class="loading-container"  *ngIf="!loaded">
          <ion-spinner></ion-spinner>
        </div>
        <div  class="cancel-container">
           <ion-row>
                <ion-grid class="inner-grid">
                    <ion-row>
                        <ion-col>Cust: &nbsp;&nbsp;{{customerCode}} </ion-col>
                        <ion-col size="auto">
                            <button class="printer-button hidden-for-print" (click)="changePrinterView()">{{viewChange === true ? 'Regular Version' : 'Printer Friendly Version'}}</button>
                        </ion-col>
                        <ion-col size="auto"><b>Report Date: </b> {{currentDate | date: 'shortDate'}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>Dept: &nbsp;&nbsp;{{dept}}  </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>Emp: &nbsp;&nbsp;{{empCode}}</ion-col>
                    </ion-row>
                    
                </ion-grid>
            </ion-row>
            <ion-grid class="main-grid" *ngFor="let wo of cancelOrders">
                <ion-row>
                    <ion-col class="bold">
                        {{wo.items[0].lastName}}, {{wo.items[0].firstName}} ({{wo.items[0].departmentCode}}-{{wo.items[0].employeeCode }})
                    </ion-col>
                    <ion-col>
                        <strong>Cancel Order:</strong> {{wo.items[0].woCode}}
                    </ion-col>
                    <ion-col>
                        <strong>Days Allowed:</strong> {{wo.theGap}}
                    </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-end ion-align-items-center">
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Stop:</strong> {{wo.items[0].stopName}}
                    </ion-col>
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Gar. ID Label:</strong> {{wo.items[0].stopCode}} {{wo.items[0].lockerNum}}
                    </ion-col>
                </ion-row>
                <ion-grid class="data-grid">
                    <ion-row class="data-headers">
                      <ion-col size="4">
                        <strong>Product</strong>
                      </ion-col>
                      <ion-col size="2">
                        <strong>Barcode #</strong>
                      </ion-col>
                      <ion-col size="2">
                        <strong>Action</strong>
                      </ion-col>
                      <ion-col size="2">
                        <strong>Action Date</strong>
                      </ion-col>
                        <ion-col size="2">
                        <strong>Late Return</strong>
                      </ion-col>
                    </ion-row>
    
                    <ion-row *ngFor="let item of wo.items" >
                      <ion-col size="4">
                        {{item.name}}
                      </ion-col>
                      <ion-col size="2">
                        {{item.garmentCode}}
                      </ion-col>
                      <ion-col size="2">
                         {{ getActionTypeText(item.action) }}
                      </ion-col>
                      <ion-col size="2">
                        {{item.actionDate  | date: 'MM/dd/yyyy'}}
                      </ion-col>
                      <ion-col size="2">
                        {{item.lateReturnText}}
                      </ion-col>
                    </ion-row>
                
                </ion-grid>
            </ion-grid>
          
        </div>
        <ion-row class="no-work-orders" *ngIf="loaded && (cancelOrders.length <= 0)">
                <ion-col>
                    No cancel Orders
                </ion-col>
            </ion-row>
    </ng-container>
</ion-content>